import { ALL_PROJECTS_ID } from '../../project/model';
import * as z from 'zod';
import { schemaV1 } from './v1';
import { schemaV2 } from './v2';
import { schemaV3 } from './v3';
import { schemaV4 } from './v4';

type SchemaV1 = z.infer<typeof schemaV1>;
type SchemaV2 = z.infer<typeof schemaV2>;
type SchemaV3 = z.infer<typeof schemaV3>;
type SchemaV4 = z.infer<typeof schemaV4>;

export const ACTUAL_VERSION = 4;
export type ActualSchema = SchemaV4;
export const SCHEMAS = [schemaV1, schemaV2, schemaV3, schemaV4];
export type Schema = SchemaV1 | SchemaV2 | SchemaV3 | SchemaV4;

export const upVersion = (state: Schema) => {
  // Описываем конвертеры из одной версии в другую.
  // Чтобы добавить новый конвертер, в case указываем прежнее значение ACTUAL_VERSION
  // и возвращаем результат с типом, который соответствует новому значению ActualSchema.

  switch (state.version) {
    case 1: {
      const result: SchemaV2 = {
        version: 2,
        data: {
          ...state.data,
          sorting: {
            ...state.data.sorting,
            fieldKey:
              state.data.sorting.fieldKey === 'updated_at'
                ? 'created_at'
                : state.data.sorting.fieldKey,
          },
        },
      };
      return result;
    }
    case 2: {
      const result: SchemaV3 = {
        version: 3,
        data: {
          ...state.data,
          project: {
            ...state.data.project,
            selectedIds:
              state.data.project.selectedId === ALL_PROJECTS_ID
                ? []
                : [state.data.project.selectedId],
          },
        },
      };
      return result;
    }
    case 3: {
      const search = { ...state.data.search };
      delete search.searchInLayers;
      const result: SchemaV4 = {
        version: 4,
        data: {
          ...state.data,
          search: {
            ...search,
            options: {
              searchInLayers: state.data.search.searchInLayers ?? false,
              searchInArchives: false,
            },
          },
        },
      };
      return result;
    }
  }
};
